import { useEffect } from 'react';

import { Container, ContainerContent, HelpPageContent } from '@/component';
import { useMainLayout } from '@/provider';

const HelpPage = () => {
  const { setTitle } = useMainLayout();

  useEffect(() => {
    setTitle('Help');
  }, [setTitle]);

  return (
    <Container>
      <ContainerContent>
        <HelpPageContent />
      </ContainerContent>
    </Container>
  );
};

export default HelpPage;
